import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"

// Duplicates review page: merge/keep decisions resolve via turbo streams
// (the pair card is removed server-side), so this controller only keeps the
// header count honest, swaps in the empty state when the queue drains, and
// surfaces a toast for the decision that just happened.
export default class extends Controller {
    static targets = ["pairs", "count", "empty", "header", "log"]

    connect() {
        this.observer = new MutationObserver(() => this.refresh())
        if (this.hasPairsTarget) this.observer.observe(this.pairsTarget, { childList: true })
        if (this.hasLogTarget) this.observer.observe(this.logTarget, { childList: true, subtree: true })
        this.boundSubmitEnd = (event) => this.submitEnded(event)
        this.element.addEventListener("turbo:submit-end", this.boundSubmitEnd)
    }

    disconnect() {
        if (this.observer) this.observer.disconnect()
        this.element.removeEventListener("turbo:submit-end", this.boundSubmitEnd)
    }

    refresh() {
        let remaining = this.hasPairsTarget ? this.pairsTarget.querySelectorAll("[data-duplicate-pair]").length : 0
        if (this.hasCountTarget) this.countTarget.textContent = remaining
        if (this.hasHeaderTarget) this.headerTarget.hidden = remaining === 0
        if (this.hasEmptyTarget) this.emptyTarget.hidden = remaining > 0
        if (this.hasLogTarget && this.logTarget.querySelector(".network-import-history-row")) this.logTarget.hidden = false
    }

    submitEnded(event) {
        if (!event.detail.success) return

        let toast = event.target.dataset.toast
        if (toast) showSystemToast(toast)
    }
}
